import script from "./AdminContent.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminContent.vue?vue&type=script&setup=true&lang=js"

import "./AdminContent.vue?vue&type=style&index=0&id=03c57da3&lang=css"

const __exports__ = script;

export default __exports__